import React from "react";
import { Helmet } from "react-helmet-async";

function About() {
  return (
    <main className="App-main magicpatern2">
      <Helmet>
        <title>À propos - Déco Ariège</title>
        <meta
          name="description"
          content="Découvrez l'histoire de notre entreprise artisanale en Ariège. Créations en bois faites main, personnalisation et fabrication locale."
        />
      </Helmet>
      <h2 className="section-title">À PROPOS DE MOI</h2>
      <div id="about">
        <section className="about">
          <p>
            Je me présente, je suis une petite entreprise de chantournage, je
            suis née en 2020, je propose différents objets, en bois et/ou en
            contreplaqué. Tous les objets sont faits à la main par moi-même. Je
            personnalise, je fais à la demande et à la commande. Tous mes objets
            sont peints à la main, si vous souhaitez sans peinture c'est
            possible, il suffit de le préciser lors de la commande.
            <br />
            <br />
            Bienvenue dans ma petite boutique artisanale située en Ariège,
            spécialisée dans la création d'objets de décoration en bois.
            Passionné par le travail du bois, j'utilise une scie à chantourner
            pour donner vie à des pièces uniques et originales. Chaque objet est
            fabriqué à la main et avec soin. Que ce soit pour embellir votre
            intérieur ou offrir un cadeau personnalisé, mes créations apportent
            une touche de nature à votre quotidien. Découvrez mon univers
            artisanal et laissez-vous charmer par l'art du chantournage !
          </p>
        </section>
        <div className="about-video">
          <iframe
            width="100%"
            height="auto"
            src="https://www.youtube.com/embed/PXO2LSQ-LQ0?autoplay=1&loop=1&playlist=PXO2LSQ-LQ0&controls=0&modestbranding=1&rel=0"
            title="Présentation vidéo de la boutique"
            frameBorder="0"
            allow="autoplay"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </main>
  );
}

export default About;
